import { t } from '../lib/i18n.js';

// Verbindungstest der Provider-Seite: Die Seite steht sofort, danach prüft der
// Browser jeden Zugang mit einem eigenen Request - alle parallel, der Balken
// zählt mit. Ergebnis je Zeile und die Liste nicht einsatzbereiter Zugänge
// schreibt dieses Modul; ohne JavaScript prüft die Seite mit ?sync=1 alles auf einmal.
// Adressen aus dem Template: data-check-url, data-login-url.
// Status und Hinweis aus der Antwort des Servers kommen schon übersetzt.
export default function providerCheck() {
  const root = document.querySelector('[data-provider-check]');
  if (!root) return;

  // Farbe des Punkts je Stand aus Labels (account_state), mitgegeben als data-states.
  const states = JSON.parse(root.dataset.states || '{}');

  const pending = Array.from(document.querySelectorAll('[data-provider-row][data-pending]'));
  const bar = root.querySelector('[data-bar]');
  const label = root.querySelector('[data-progress-label]');
  let done = 0;

  function progress() {
    bar.value = pending.length > 0 ? Math.round(done / pending.length * 100) : 100;
    label.textContent = t('{done} von {total} Zugängen geprüft', { done: done, total: pending.length });
  }

  function show(row, data) {
    row.dataset.state = data.state;
    row.removeAttribute('data-pending');

    const status = row.querySelector('[data-status]');
    const dot = document.createElement('span');
    dot.className = 'dot dot-' + (states[data.state] ? states[data.state].tone : 'info');
    status.replaceChildren(dot, document.createTextNode(data.status || ''));
    row.querySelector('[data-note]').textContent = data.note || '';
    row.querySelector('[data-latency]').textContent = data.latency == null ? '–' : data.latency + ' ms';
  }

  async function check(row) {
    let data;
    try {
      const res = await fetch(root.dataset.checkUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new URLSearchParams({ _token: root.dataset.token, id: row.dataset.providerRow }),
      });
      // Sitzung abgelaufen: zur Anmeldung, danach zurück auf diese Seite.
      if (res.status === 401) {
        window.location.href = root.dataset.loginUrl + '?next=' + encodeURIComponent(window.location.pathname);
        return;
      }
      data = res.ok
        ? await res.json()
        : {
            state: 'error',
            status: 'HTTP ' + res.status,
            note: res.status === 419
              ? t('Sitzung abgelaufen – Seite neu laden.')
              : t('Test fehlgeschlagen – Seite neu laden oder später erneut versuchen.'),
          };
    } catch (e) {
      data = { state: 'error', status: t('Keine Antwort'), note: t('Der Server hat nicht geantwortet – Seite neu laden.') };
    }
    show(row, data);
    done++;
    progress();
  }

  // Am Ende wie die Fassung ohne JavaScript: welche Zugänge nicht einsatzbereit sind.
  function summarize() {
    const rows = Array.from(document.querySelectorAll('[data-provider-row]'));
    const notReady = rows.filter((row) => row.dataset.state === 'error' || row.dataset.state === 'missing');
    bar.classList.add('is-done');
    const spinner = root.querySelector('[data-spinner]');
    if (spinner) spinner.remove();
    label.textContent = notReady.length
      ? t('Alle {total} Zugänge geprüft – {count} nicht einsatzbereit', { total: pending.length, count: notReady.length })
      : t('Alle {total} Zugänge geprüft – alle einsatzbereit', { total: pending.length });

    const notice = document.querySelector('[data-not-ready]');
    if (!notice || notReady.length === 0) return;
    notice.querySelector('[data-not-ready-title]').textContent =
      t('{count} von {total} Zugängen sind nicht einsatzbereit', { count: notReady.length, total: rows.length });
    notice.querySelector('[data-not-ready-list]').replaceChildren(...notReady.map((row) => {
      const item = document.createElement('li');
      const name = document.createElement('strong');
      name.textContent = row.dataset.label;
      item.append(name, document.createTextNode(' — ' + row.querySelector('[data-note]').textContent));
      return item;
    }));
    notice.hidden = false;
  }

  progress();
  Promise.all(pending.map(check)).then(summarize);
}
